<template>
<div class="container">
    <nav class="breadcrumb" aria-label="breadcrumb">
        <ol class="breadcrumb-list">
            <!-- 首页 -->
            <li class="breadcrumb-item">
                <router-link to="/"><i class="fas fa-home"></i> 首页</router-link>
            </li>
            
            <!-- 一级分类 -->
            <li class="breadcrumb-item">
                <router-link to="/blog">Blog</router-link>
            </li>
            
            <!-- 当前页面（不加链接，添加 is-active 类） -->
            <li class="breadcrumb-item is-active">
                <span>{{ title }}</span>
            </li>
        </ol>
    </nav>
    <h1>{{ title }}</h1>
    <div style="height:25px" aria-hidden="true"></div>
    
    <p>在向日葵乐园种植、制作并赚钱——唯一由社区控制代币、NFT 和资源的区块链游戏。</p>

    <p>通过玩游戏赚取游戏内 ERC20 SFL 代币，可用于制作配方、开采资源和发展农场。</p>

    <p>游戏内置了供需机制来控制基础代币经济学。目标是奖励早期加入游戏的农民并推动稀缺性。当总供应量增加时，获得的奖励会减少。那些早期努力的人会因为他们的付出得到丰厚回报。</p>
    
    <p>像这种经营类游戏，就是闭环的玩法。</p>

    <h2>拓张土地，升级岛屿</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/sl01.png" alt="Sunflower Land">
    <div style="height:25px" aria-hidden="true"></div>
    <p>初始岛屿只有春季，能种植的只有春季作物。初始岛屿中有四个初始的建筑，包括<u>用户房间</u>、<u>锻造台</u>、<u>种子商店</u>、<u>初始厨房</u>。</p>
    <p>点击[拓张]，查看升级所需的等级和资源。拓张到一定的土地数量，就能升级岛屿，获得更多的资源。</p>
    <div style="height:25px" aria-hidden="true"></div>

    <h2>烹饪食物，升级等级</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/sl02.png" alt="Sunflower Land">
    <div style="height:25px" aria-hidden="true"></div>
    <p>厨房，就可以选择烹饪的食物。</p>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/sl03.png" alt="Sunflower Land">
    <div style="height:25px" aria-hidden="true"></div>
    <p>选择食物投喂用户角色，获得xp值，以便提升等级。</p>
    <div style="height:25px" aria-hidden="true"></div>

    <h2>送货赚金币，赚SFL</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/sl04.png" alt="Sunflower Land">
    <div style="height:25px" aria-hidden="true"></div>
    <p>前往广场，找到相应的npc商人，进行交易，获得金币。</p>
    <div style="height:25px" aria-hidden="true"></div>
    <div style="height:25px" aria-hidden="true"></div>
    <div style="height:25px" aria-hidden="true"></div>
    <p>点击下面链接，加入[向日葵乐园]。👇👇👇</p>
    <a href="https://sunflower-land.com/play/?ref=wildboy" target="_blank" style="font-size: 2rem;">https://sunflower-land.com/play/?ref=wildboy</a>
  </div>
</template>

<script>
export default{
    name: 'SunflowerLand',
    data(){
        // data 必须是一个函数，以避免多个实例间的数据共享
        return {
            title: 'sunflower land 新手攻略',
            showMessage: true,
            
        }
    },
    methods: {
        // 定义事件处理函数
        updateTitle(newTitle) {
          this.title = newTitle;
        }
    },
    mounted() {
        // 组件挂载到 DOM 后执行
        console.log('组件已挂载');
    }
}
</script>

<style scoped>

.container {
  padding: 20px;
  background-color: #2f3045;
  color: #fff;
  max-width: 1200px;
    margin: 20px auto;
    width: 100%;
    box-sizing: border-box;
}
h2{
    color: #03e1e4;
}
/* 面包屑容器 */
.breadcrumb {
    /* 使用 Flexbox 排列元素 */
    display: flex;
    /* 内边距 */
    padding: 15px 0px;
    margin: 0 auto;
}
/* 列表样式：去除默认的圆点 */
.breadcrumb-list {
    display: flex;
    list-style: none;
    /* 确保列表项之间有间隔 */
    margin: 0;
    padding: 0;
    flex-wrap: wrap; /* 允许换行，防止长路径溢出 */
}

/* 每个层级的样式 */
.breadcrumb-item {
    color: #fff;
    font-size: 14px;
}

/* 链接样式 */
.breadcrumb-item a {
    color: #fff;
    text-decoration: none;
    transition: color 0.2s ease;
}

.breadcrumb-item a:hover {
    color: #fff;
    text-decoration: underline;
}

/* 当前页面（通常是最后一个）的样式 */
.breadcrumb-item.is-active {
    color: #07e1e4;
    font-weight: 500;
}

/* 分隔符：使用伪元素在每个项目后面添加斜杠 */
.breadcrumb-list .breadcrumb-item:not(:last-child)::after {
    content: "/";
    margin: 0 8px;
    color: #fff;
}

/* 隐藏最后一个项目的分隔符 */
.breadcrumb-item.is-active::after {
    display: none;
}
</style>